module.exports = __webpack_public_path__ + "img/journey.77ac24ea.svg";